<div class="p-2 min-h-screen">
    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-2">
        <h3 class="font-bold">{{ '::Deliveries' | abpLocalization }}</h3>
    </div>

    <!-- filtro fecha -->
    <div class="flex flex-col mb-4">
        <div class="w-full px-1 flex md:justify-start">
            <app-metro-date-input-picker class="w-full md:max-w-sm" [modeInput]="'range'" [size]="'md'"
                [startDateInput]="dateRange.start" [endDateInput]="dateRange.end"
                (rangeSelectedChange)="onDateRangeChange($event)">
            </app-metro-date-input-picker>
        </div>
    </div>

    @if (loading) {
    <div class="flex justify-center p-4">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    }

    @if (!loading) {
    <div class="grid gap-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <app-metro-order-card-item *ngFor="let order of orders" [dateOrder]="order.creationTime" [status]="order.status"
            [itemCount]="order.itemCount" [totalPrice]="order.totalPrice" [orderNumber]="order.orderNumber"
            [id]="order.id" [navigationPath]="'order'" [queryParams]="{ fromDeliveries: true }">
        </app-metro-order-card-item>
    </div>}

    @if (!loading && orders.length === 0) {
    <div class="text-center p-4 text-gray-500">
        <p>{{ '::NoOrdersFound' | abpLocalization }}</p>
    </div>
    }
</div>